import 'jquery';
import '../utils/slick.js';

$(function () {
    var sliderReview = $('.assist-reviews .assist-reviews__row');
    var sliderFeatures = $('.assist-features .assist-features__row');
    var sliderReviewItems = $('.assist-reviews .assist-reviews__review');
    var sliderFeaturesItems = $('.assist-features .assist-features__feature');
    var isMobile = false;

    function initSlider(slider, options) {
        if (!slider.hasClass('slick-initialized')) {
            slider.slick(options);
        }
    }

    function destroySlider(slider) {
        if (slider.hasClass('slick-initialized')) {
            slider.slick('unslick');
        }
    }

    function removeSalAnimate(items){
        items.each(function () {
            $(this).removeClass('sal-animate');
            $(this).removeAttr('data-sal');
            $(this).removeAttr('data-sal-duration');
            $(this).removeAttr('data-sal-delay');
        });
    }

    function checkViewport() {
        var viewportWidth = $(window).width();
        isMobile = viewportWidth <= 767;

        if (isMobile) {
            removeSalAnimate(sliderReviewItems);
            removeSalAnimate(sliderFeaturesItems);
            
            initSlider(sliderReview, {
                slidesToShow: 1,
                arrows: false,
                dots: true
            });

            initSlider(sliderFeatures, {
                slidesToShow: 1,
                prevArrow: '<div class="arrow-left"></div>',
                nextArrow: '<div class="arrow-right"></div>',
                dots: true
            });
        } else {
            destroySlider(sliderReview);
            destroySlider(sliderFeatures);
        }
    }

    checkViewport();
    $(window).on('resize orientationchange', checkViewport);
});